import createReducer from '../utils/createReducer';
import {
  BANK_CASE_STATES_REQUEST,
  BANK_CASE_STATES_FAILURE,
  BANK_CASE_STATES_SUCCESS,

} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [BANK_CASE_STATES_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [BANK_CASE_STATES_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [BANK_CASE_STATES_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/bankCaseStates.js